import React from 'react';

import { type DataOperationsError } from '@/errorHandling/DataOperationsError.util.tsx';

export const DataOperationsErrorContext = React.createContext({
  handleDataOperationError: (_error: DataOperationsError) => {
    console.log('Handling Error');
  },

  handleMinorError: (_error?: string) => {
    console.log('Handling Minor Error');
  },
  handleOperationSuccess: (_message?: string) => {
    console.log('Handling operation success');
  },
});
